module.exports = __webpack_public_path__ + "img/front.ee45bfac.png";